<template>
    <Header/>

    <section class="section bg-light"
             style="min-height: 90vh">
        <BContainer>

            <BRow v-if="details">
                <BCol md="3">
                    <div v-if="details.logo">
                        <img :src="`${env.url}uploads/selection-processes/${details.logo}`"
                             alt=""
                             style="height: 150px"
                             class="img-fluid">
                    </div>
                </BCol>

                <BCol :md="details.logo ? '9' : '12'"
                      :class="details.logo ? 'my-auto' : 'my-4'">
                    <h2 class="mb-3 fw-semibold lh-base">{{ details.title }}</h2>
                </BCol>

                <BCol xxl="12">
                    <hr class="text-primary">
                </BCol>

                <BCol md="6" v-if="details.start_in && details.closed_in">
                    <div>
                        <i class="ri-calendar-2-line text-primary me-1 align-bottom"></i>
                        {{ convertDateText(details.start_in.date) }} -
                        {{ convertDateText(details.closed_in.date) }}
                    </div>
                </BCol>

                <BCol md="6"
                      v-if="details.city && details.state">
                    <div>
                        <i class="ri-map-pin-line text-primary me-1 align-bottom"></i>
                        {{ details.city.name }}/{{ details.state.uf }}
                    </div>
                </BCol>

                <BCol xxl="12">
                    <hr class="text-primary">
                </BCol>

                <BCol md="12"
                      v-html="details.description"
                      class="text-justify"></BCol>

                <BCol xxl="12">
                    <hr class="text-primary">
                </BCol>

                <BCol xxl="12">
                    <h5 class="mb-3 fw-semibold lh-base">Etapas do processo</h5>
                </BCol>

                <BCol xxl="12"
                      v-for="(module, i) in steps"
                      :key="`module-${i}`"
                      class="d-flex mb-2">
                    <div class="rounded-circle bg-primary balloon text-center text-white fw-bold">{{ i + 1 }}</div>

                    <span class="ms-2 fw-semibold my-auto">{{ module }}</span>
                </BCol>

                <BCol xxl="12"
                      class="text-center"
                      v-if="user">

                    <BAlert v-if="registered"
                            show
                            variant="info"
                            class="mt-3">
                        Você já iniciou a inscrição neste processo seletivo! Acesse suas vagas para mais detalhes.
                    </BAlert>

                    <BButton v-else
                             variant="primary"
                             style="width: 200px"
                             @click="enrollment">
                        <span style="font-size: 16px"
                              v-if="!loading">
                            Inscrever-se
                        </span>

                        <BSpinner v-else/>

                    </BButton>
                </BCol>

                <BCol xxl="12"
                      v-else-if="!user">
                    <BAlert show
                            variant="danger"
                            class="mt-3 text-center">
                        Para se candidatar à vaga, é necessário fazer login ou criar uma conta (menu no canto superior
                        direito da tela).
                    </BAlert>
                </BCol>

            </BRow>

            <BRow v-else>
                <BCol class="text-center">
                    <BSpinner/>
                </BCol>
            </BRow>

        </BContainer>
    </section>

    <Footer/>
</template>

<script setup>
import Header from './header.vue'
import Footer from "@/views/public/footer.vue";
import {useRoute} from "vue-router";
import {computed, onMounted, ref} from "vue";
import http from '@/http'
import {notifyError, notifySuccess} from "@/components/composables/messages";
import {convertDateText, decodeId, encondeId} from "@/components/composables/functions";
import store from "@/state/store";
import router from '@/router'
import env from "@/env";

const route = useRoute();

const user = computed(() => {
    getData();
    return store.state.auth.currentUser
});

const steps = ref(['Inscrição', 'Testes', 'Avaliação Curricular', 'Case', 'Entrevistas com mandatário']);

const details = ref(null);
const loading = ref(false);
const registered = ref(false);

function enrollment() {
    if (user.value) {
        loading.value = true;

        const formData = {
            candidate: user.value.id,
            selective_process: route.params.id
        }

        http.post('inscricao', formData)
            .then(response => {
                router.push('/processo-seletivo/' + encondeId(response.data.enrollment) + '/' + route.params.id)
                notifySuccess(response.data.message);
            })
            .catch(e => {
                console.error(e);
                notifyError(e.response.data.message)
            })
            .finally(() => {
                loading.value = false;
            })
    } else {
        notifyError('Você precisa estar logado para se candidatar a vaga!');
    }
}

function getData() {
    const id = route.params.id;
    http.get(`processos-seletivos/detalhes/${id}`)
        .then(response => {
            details.value = response.data.message;
            registered.value = response.data.registered;

            if (response.data.message.type === 2) {
                steps.value = ['Inscrição', 'Testes', 'Aguardar'];
            }

            if (response.data.message.steps.length > 0) steps.value = response.data.message.steps;
        })
        .catch(e => {
            console.error(e);
            notifyError('Erro ao carregar informações!')
        })
}

onMounted(() => {
    if (decodeId(route.params.id) == 88) steps.value = ['Cadastro', 'Manifestação de Interesse de Cargos'];
    getData();
})


</script>
